var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "POIUploadModal",
            size: "md",
            "content-class": "menu-bg-blue-transparent-modal",
            title: "POI Upload",
            "hide-footer": "",
            "hide-header-close": "",
            scrollable: "",
          },
          on: { hide: _vm.clear },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "brow-flex" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("label", { staticClass: "label-align" }, [
                      _vm._v("POI Name"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "9" } },
                    [
                      _c("b-form-input", {
                        staticClass: "form-control poi-upload-formcontrol",
                        attrs: {
                          type: "text",
                          name: "name",
                          placeholder: "POI Name",
                        },
                        model: {
                          value: _vm.poi_name,
                          callback: function ($$v) {
                            _vm.poi_name = $$v
                          },
                          expression: "poi_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "brow-flex mt-2" },
                [
                  _c("b-col", { attrs: { cols: "6" } }, [
                    _c("label", [_vm._v("Attach File (.csv)")]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "6" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "small text-primary",
                        staticStyle: { "margin-left": "3px" },
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.generateSample.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("(Download Sample Template)")]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "6" } }, [
                    _c("input", {
                      attrs: {
                        type: "file",
                        name: "file",
                        id: "poiFile",
                        multiple: "false",
                        accept: ".csv",
                      },
                      on: { change: _vm.handleFileUpload },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "b-row",
                    {
                      staticClass: "mt-4",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center",
                        "flex-direction": "row",
                        gap: "2%",
                      },
                    },
                    [
                      !_vm.done
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-center py-1",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "highlightLoader p-1 spinner-border-md mr-2 mt-1",
                                },
                                [_vm._v("Uploading File...")]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-md highlightLoader",
                                attrs: {
                                  role: "status",
                                  "aria-hidden": "true",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _c(
                    "b-row",
                    {
                      staticClass: "mt-4",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.uploadFile },
                        },
                        [_vm._v("Upload File")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }